import { infoService, utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export class TargetDropdownViewModel {
    targetOptions = [];
    selectedTarget = null;
    constructor(initialTarget = null) {
      this.selectedTarget = initialTarget;
    }

    static async create(initialTarget = null) {
      const viewModel = new TargetDropdownViewModel(initialTarget);
      await viewModel.loadConversionSettings();
      return viewModel;
    }
    async loadConversionSettings() {
      try {
        const response = await infoService.getConversionSettings();
        if (!(response && response.data)) {
          this.targetOptions = [];
          return;
        }
        const processedData = response.data.map((item, index) => {
          if (!item.value && item.value !== 0) {
            return { ...item, value: `option_${index}` };
          }
          return item;
        });
        this.targetOptions = processedData;
      } catch (error) {
        console.error('Error loading conversion settings:', error);
        utilities.errorHandler(error);
      }
    }

    get dropdownConfig() {
      const options = Array.isArray(this.targetOptions) ? this.targetOptions : [];
      return {
        options,
        getOptionKey: option => option?.value,
        getOptionLabel: option => option?.name || '',
        clearable: true
      };
    }



}